import React, {forwardRef} from 'react';
import {TextInput} from '@unthinkable/react-core-components';
import TextAreaAutoResize from 'react-textarea-autosize';

const BasicTextAreaInput = (props, ref) => {
  return <TextInput {...props} ref={ref} as={TextAreaAutoResize} />;
};

export default forwardRef(BasicTextAreaInput);
